import WebApp from '@twa-dev/sdk';

export const initTelegramApp = () => {
  // Расширяем на весь экран
  WebApp.expand();
  
  // Включаем подтверждение закрытия
  WebApp.enableClosingConfirmation();
  
  // Устанавливаем основной цвет
  WebApp.setHeaderColor('#000000');
  
  // Устанавливаем цвет фона
  WebApp.setBackgroundColor('#000000');
};

export const telegramApp = WebApp; 